import { useFlags } from '@mint-lib/routing-context';

export const useActivityPlatformsV2FF = () => {
  const ff = useFlags('@mint/arm', ['activityPlatformsV2']);

  return ff.activityPlatformsV2.enabled;
};
